/**
 * Check if the URL is an external link
 * @param url - The URL to check if it is an external link
 * @returns - A boolean indicating if the URL is an external link
 */
export const isExternalLink = (url: string) => {
  return /^(http|https):\/\//.test(url);
};
